import { Box, Grid, IconButton, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";

import { formatEpochTimestamp } from "utils/time";

import { ActionItemPreview } from "..";
import styles from "./styles";

interface IProps {
  preview: ActionItemPreview;
}

export default function ActionItem({ preview }: IProps) {
  return (
    <Grid container gap={1}>
      <Grid
        item
        xs
        container
        alignItems="center"
        columnSpacing={1}
        sx={styles.accordion}
      >
        <Grid item md="auto">
          <IconButton size="small" color="primary">
            <Box component="i" className={`fa-regular fa-star`} />
          </IconButton>
        </Grid>
        <Grid item md>
          <Box component="div">
            <Grid container alignItems="center">
              <Grid
                item
                container
                alignItems="center"
                xs="auto"
                sx={{ mr: 1, mb: 0.5 }}
              >
                <Typography component="div" sx={styles.participants}>
                  {preview.participants}
                </Typography>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  sx={styles.lastThreadLength}
                >
                  3
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Typography sx={styles.subject}>{preview.subject}</Typography>

          <Typography
            dangerouslySetInnerHTML={{
              __html: preview.snippet,
            }}
            sx={styles.snippet}
          ></Typography>
        </Grid>

        <Grid item md="auto">
          <Typography
            variant="caption"
            color="textSecondary"
            sx={styles.formattedDate}
            component="div"
          >
            {formatEpochTimestamp({
              epochTimestamp: Number(preview.date),
              fullDate: true,
            })}
          </Typography>
        </Grid>
      </Grid>
      <Grid container item xs="auto" sx={styles.accordionActions}>
        <Grid
          item
          container
          alignItems="center"
          xs
          sx={{ borderRight: `1px solid ${grey[300]}`, px: 1 }}
        >
          <IconButton size="small">🔕</IconButton>
        </Grid>
        <Grid
          item
          container
          alignItems="center"
          xs
          sx={{ borderRight: `1px solid ${grey[300]}`, px: 1 }}
        >
          <IconButton size="small">😴</IconButton>
        </Grid>
        <Grid item container alignItems="center" xs sx={{ px: 1 }}>
          <IconButton size="small">
            <Box component="span" className="fa-solid fa-plus" />
          </IconButton>
        </Grid>
      </Grid>
    </Grid>
  );
}
